import { client } from '../../api';

export const createDocusignEnvelope = (docId: string, employeeId: string) =>
  client.post(`/docusign/${docId}/create-envelope`, { employeeId });
